import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { MaterialUIControllerProvider } from "context";
import "./index.scss";
import { Toaster } from "sonner";
import "react-datepicker/dist/react-datepicker.css";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <MaterialUIControllerProvider>
    <BrowserRouter>
      <Toaster position={'top-right'} richColors theme='light' closeButton={true} gap={5}/>
      <App />
    </BrowserRouter>
  </MaterialUIControllerProvider>
);
